import { Label as BaseLabel } from 'semantic-ui-react';
import styled from 'styled-components';

const ServiceGroupName = styled(BaseLabel)`
    background-color: #3bb5ed !important;
    color: #FFF !important;
`;

export default ServiceGroupName;
